import { Controller } from "@hotwired/stimulus"

// Tabs + panels. Most pages style tabs with the `tab` / `tab-active` component
// classes, which stay the default. A page can pass its own instead through
// data-tabs-active-class / data-tabs-inactive-class (the autoboost show page's
// segmented switcher does), and may add an `indicator` target that slides
// under the selected tab.
export default class extends Controller {
  static targets = ["tab", "panel", "indicator"]
  static classes = ["active", "inactive"]

  connect() {
    const param = new URLSearchParams(window.location.search).get("tab")
    // Ignore a ?tab= this page doesn't render (e.g. an admin-only tab link
    // opened by a customer) instead of hiding every panel.
    if (param && this.tabTargets.some(tab => tab.dataset.tab === param)) this.activate(param)

    this.onResize = () => this.moveIndicator(false)
    window.addEventListener("resize", this.onResize)
    this.moveIndicator(false)
  }

  disconnect() {
    window.removeEventListener("resize", this.onResize)
  }

  switch(event) {
    const selectedTab = event.currentTarget.dataset.tab
    this.activate(selectedTab)
    const url = new URL(window.location)
    url.searchParams.set("tab", selectedTab)
    history.pushState({}, "", url)
  }

  activate(selectedTab) {
    const on = this.hasActiveClass ? this.activeClasses : ["tab-active"]
    const off = this.hasInactiveClass ? this.inactiveClasses : ["tab"]

    this.tabTargets.forEach(tab => {
      const selected = tab.dataset.tab === selectedTab
      tab.classList.remove(...(selected ? off : on))
      tab.classList.add(...(selected ? on : off))
      tab.setAttribute("aria-selected", String(selected))
    })
    this.moveIndicator(true)

    this.panelTargets.forEach(panel => {
      if (panel.dataset.tab === selectedTab) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }

  // Slides the indicator under the selected tab. `animate` is false on first
  // paint and resize so it doesn't sweep in from the left edge.
  moveIndicator(animate = true) {
    if (!this.hasIndicatorTarget) return

    const indicator = this.indicatorTarget
    const tab = this.tabTargets.find(t => t.getAttribute("aria-selected") === "true")
    if (!tab) {
      indicator.style.opacity = "0"
      return
    }

    if (!animate) indicator.style.transition = "none"
    indicator.style.left = `${tab.offsetLeft}px`
    indicator.style.width = `${tab.offsetWidth}px`
    indicator.style.opacity = "1"
    if (!animate) {
      void indicator.offsetWidth // flush the jump before re-enabling transitions
      indicator.style.transition = ""
    }
  }
}
